import { useEffect, RefObject, useCallback } from 'react';

export const useScannerFocus = (
  inputRef: RefObject<HTMLInputElement>,
  isActive: boolean
) => {
  const handleFocusManager = useCallback(() => {
    const input = inputRef.current;
    if (!isActive || !input) return;

    setTimeout(() => {
      const activeElement = document.activeElement;

      const isUserBusy = activeElement?.closest(
        '.MuiAutocomplete-root, .MuiMenu-root, .MuiDialog-root, .MuiPopover-root, button, input:not([readonly]), textarea'
      );

      if (!isUserBusy && activeElement !== input) {
        input.focus();
      }
    }, 50);
  }, [isActive, inputRef]);

  useEffect(() => {
    if (!isActive) return;

    const input = inputRef.current;
    input?.addEventListener('blur', handleFocusManager);
    document.addEventListener('click', handleFocusManager);
    window.addEventListener('focus', handleFocusManager);
    handleFocusManager();

    return () => {
      input?.removeEventListener('blur', handleFocusManager);
      document.removeEventListener('click', handleFocusManager);
      window.removeEventListener('focus', handleFocusManager);
    };
  }, [isActive, handleFocusManager]);
};
